module.exports = __webpack_public_path__ + "static/media/whatsapp.fa16a657.svg";